"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        button: function (_a) {
            var color = _a.color;
            return ({
                paddingLeft: 22,
                paddingRight: 12,
                borderWidth: 0,
                borderStyle: 'none',
                borderRadius: 4,
                backgroundColor: (0, styleUtilities_1.withOpacity)(color, 0.2),
                cursor: 'pointer',
                height: 32,
                fontFamily: theme_1.default.fontFamily,
                '&:hover, &:focus-visible': {
                    border: "1px solid ".concat(color),
                    paddingLeft: 21,
                    paddingRight: 11,
                    outline: 'none',
                },
            });
        },
        innerContainer: {
            display: 'grid',
            gridTemplateColumns: 'auto auto',
            columnGap: 12,
            alignItems: 'center',
        },
        buttonLoading: {
            cursor: 'progress',
            pointerEvents: 'none',
        },
        chevron: {
            transition: theme_1.default.transitions.easeOutFast,
        },
        chevronOpened: {
            transform: 'rotate(-180deg)',
        },
        circularProgress: {
            width: 20,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        statusText: {
            textTransform: 'capitalize',
        },
        subText: {
            marginLeft: '1ch',
            lineHeight: '16px',
        },
        content: {
            padding: '8px 0px',
        },
        divider: {
            width: '100%',
        },
        additionalContent: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            padding: '0px 24px 16px',
        },
    });
});
